module.exports = __webpack_public_path__ + "media/NvShen_2.792f27b3.mp3";